import {
  Users,
  GraduationCap,
  Building2,
  ClipboardList,
  Sparkles,
  Layers,
  BookOpen,
  LifeBuoy,
  Compass,
} from 'lucide-react'

/**
 * The admin is three sections — PEOPLE, CONTENT, HELP — and you are in exactly
 * one of them at a time.
 *
 * Every tab used to sit in one bar on every page, which made eleven
 * destinations compete for attention on a page you had already chosen. /admin
 * is now a hub of three, and each section page shows only its own tabs plus the
 * way back.
 *
 * This lives beside the components rather than inside one because both the hub
 * and the tab bar read it, and a component module that also exports data is a
 * component module that stops hot-reloading.
 */
export const SECTIONS = [
  {
    id: 'people',
    name: 'People',
    icon: Users,
    blurb: 'Who is who, how they are getting on, and which team they sit in.',
    pages: [
      { to: '/admin/people', icon: Users, label: 'Crew', hint: 'Department, manager, role and degrees held' },
      { to: '/admin/progress', icon: ClipboardList, label: 'Progress', hint: 'Completion, scores, resets and reissues' },
      { to: '/admin/departments', icon: Building2, label: 'Departments', hint: 'Which degrees a department confers' },
    ],
  },
  {
    id: 'content',
    name: 'Content',
    icon: Layers,
    blurb: 'Degrees, the courses they are built from, and the modules inside.',
    pages: [
      { to: '/admin/degrees', icon: GraduationCap, label: 'Degrees', hint: 'Which courses each degree contains' },
      { to: '/admin/courses', icon: Compass, label: 'Courses', hint: 'What each course holds, and which degrees use it' },
      { to: '/admin/modules', icon: Layers, label: 'Modules', hint: 'View, edit and delete published modules' },
      { to: '/admin/lessons', icon: BookOpen, label: 'Lessons', hint: 'Every lesson, under the module it belongs to' },
    ],
    // Not a tab: the tool a module is made WITH, rather than a place things
    // live. It takes over the whole screen, so it reads as an action.
    action: { to: '/admin/studio', icon: Sparkles, label: 'AI Studio', hint: 'Create a new module with AI' },
  },
  {
    id: 'help',
    name: 'Help',
    icon: LifeBuoy,
    blurb: 'How to build a module, and how the pieces fit together.',
    pages: [
      { to: '/admin/docs', icon: LifeBuoy, label: 'Guides & Docs', hint: 'Developer and module creation guides' },
    ],
  },
]

export function sectionForPath(pathname) {
  return SECTIONS.find((s) => s.pages.some((p) => pathname.startsWith(p.to))) || null
}
